import superagent from '@ott/superagent';

import T from '../types';

import { DAYS_TO_SHOW } from '../index';

function formatDate(date) {
  return date.toISOString().split('T')[0];
}

function getStartDate() {
  const date = new Date();
  date.setDate(date.getDate() + 1);

  return formatDate(date);
}

const apiAdditionalConfig = {
  // допустимое смещение в прошлое даты поиска
  searchDateRange: 1,
  // соотношение кол-ва пропусков в разные дни поиска
  // приоритет за свежими данными
  searchCountDiff: 0.1,
};

let lastSearchTime = null;
export default ({ nights, toCountryId, fromCityId }) => {
  return async (dispatch) => {
    dispatch({ type: T.GET_PRICES_BY_DAYS });

    lastSearchTime = Date.now();
    const currentSearchTime = Date.now();
    const response = await superagent
      .get('/_tours/calendar/getPricesByDays')
      .query({
        ...apiAdditionalConfig,
        nights,
        toCountry: toCountryId,
        fromCity: fromCityId,
        days: DAYS_TO_SHOW,
        startDate: getStartDate(),
      })
      .catch((error) => {
        dispatch({ type: T.GET_PRICES_BY_DAYS_FAIL, error });
      });

    if (response && currentSearchTime === lastSearchTime) {
      const {
        body: { result, error },
      } = response;

      if (error) {
        dispatch({ type: T.GET_PRICES_BY_DAYS_FAIL, error });
      } else {
        dispatch({ type: T.GET_PRICES_BY_DAYS_SUCCESS, result });
      }
    }
  };
};
